import { CHART_COLORS, COMPARISON_CHART_COLOR, SINGLE_CHART_COLOR } from '../constants';
import { GChartProvider } from '~/presentation/charts';

interface ReportChartContainerProps {
  children: React.ReactNode;
}

export const ReportChartContainer: React.FC<ReportChartContainerProps> = ({ children }) => {
  return (
    <GChartProvider
      minHeight={350}
      seriesColors={{
        comparison: COMPARISON_CHART_COLOR,
        single: SINGLE_CHART_COLOR,
        all: CHART_COLORS,
      }}
    >
      {children}
    </GChartProvider>
  );
};
